import React from 'react'

// eslint-disable-next-line jsx-a11y/anchor-has-content
const Link = props => <a rel="noreferrer" {...props} />

export default Link
